var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M12 2.429l1.974 1.691a.5.5 0 0 1-.326.88H9.352a.5.5 0 0 1-.326-.88L11 2.43V0h1v2.429zM14 14v1h-1v-1H3v1H2v-1H1v-2c0-.364.097-.706.268-1H1V9a1 1 0 0 1 1-1 2 2 0 0 1 2-2h8a2 2 0 0 1 2 2 1 1 0 0 1 1 1v2h-.268c.17.294.268.636.268 1v2h-1zm-1-5V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2h10V9zm0 2H3a1 1 0 0 0-1 1v1h12v-1a1 1 0 0 0-1-1z" })
  );
});